/* eslint-disable no-unused-vars */
import { axios } from '../index'
const resource_complete = '/auth/complete_first_login'
const resource_logout = '/v1/stay/logout';

export default {
  /**
   * ログイン処理
   */
  postLogin(params) {
    const data = {
      data: {
        userInfo: '4df3dc72-ab60-4177-a285-4e56f7b177fb',
        contractInfo: [
          {
            companyCd: 'C10006F3W',
            customerNo: '400000000191936',
            companyName: 'テスト法人リステッドコース【A】',
            subscriptions: [
              {
                boServiceCode: 'BS',
                torinoMembrNo: '449901000000003'
              }
            ]
          },
          {
            companyCd: 'C10006C5V',
            customerNo: '102461000000418',
            companyName: '複数団体テスト２',
            subscriptions: [
              {
                boServiceCode: 'BS',
                torinoMembrNo: '102461000000418'
              }
            ]
          }
        ]
      }
    }
    return new Promise((resolve) => {
      return resolve(data)
    })
  },
  /**
   * redisに保存（session更新処理）
   */
  postSession(params) {
    const data = {
      data: {
        sessionKey: 'dummy'
      }
    }
    return new Promise((resolve) => {
      return resolve(data)
    })
  },
  /**
   * 初回ログイン完了
   */
  putComplete(params) {
    const data = {}
    return new Promise((resolve) => {
      return resolve(data)
    })
  },
  checkLoginRakuten() {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          data: {
            login: true
          }
        })
      })
    })
  },
  /**
   * ログアウト
   */
  getLogout() {
    return axios.get(`${resource_logout}`);
  }
}
